import { Injectable, inject, signal } from '@angular/core';
import { UserPreferencesStore } from '@core/user-preferences';
import type { AuthSessionResponse } from '@shared/models/auth.model';

@Injectable({ providedIn: 'root' })
export class AuthSessionStateService {
  private readonly preferences = inject(UserPreferencesStore);
  private readonly currentSession = signal<AuthSessionResponse | null>(null);
  private epoch = 0;

  readonly session = this.currentSession.asReadonly();

  get generation(): number {
    return this.epoch;
  }

  invalidate(): void {
    this.epoch += 1;
    this.currentSession.set(null);
    this.preferences.clear();
  }

  /** Une réponse obtenue avant une invalidation ne doit jamais rouvrir la session. */
  accept(session: AuthSessionResponse, generation: number): void {
    if (generation === this.epoch) this.currentSession.set(session);
  }
}
